/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeeOption } from './FeeOption';
import {
    FeeOptionFromJSON,
    FeeOptionFromJSONTyped,
    FeeOptionToJSON,
} from './FeeOption';

/**
 * Global immunization catalog item merged with the current tenant's fee options. Includes inactive items (with active: false) so historical records and orphaned fee entries still render; clients must exclude inactive items from new-record selection.
 * @export
 * @interface ImmunizationDescription
 */
export interface ImmunizationDescription {
    /**
     * Catalog item id (immutable). Clients send it as the immunization's value.catalog_item_id when recording, and as feeEntryId when charging.
     * @type {string}
     * @memberof ImmunizationDescription
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationDescription
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationDescription
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationDescription
     */
    prescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationDescription
     */
    din?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImmunizationDescription
     */
    active?: boolean;
    /**
     * The tenant's fee options for this immunization. Empty/absent = no charging offered at administration time.
     * @type {Array<FeeOption>}
     * @memberof ImmunizationDescription
     */
    fees?: Array<FeeOption>;
    /**
     * DEPRECATED back-compat for pre-fee-schedule clients: amount of the first fee option. Use fees.
     * @type {number}
     * @memberof ImmunizationDescription
     */
    price?: number;
}

/**
 * Check if a given object implements the ImmunizationDescription interface.
 */
export function instanceOfImmunizationDescription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ImmunizationDescriptionFromJSON(json: any): ImmunizationDescription {
    return ImmunizationDescriptionFromJSONTyped(json, false);
}

export function ImmunizationDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImmunizationDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'prescription': !exists(json, 'prescription') ? undefined : json['prescription'],
        'din': !exists(json, 'din') ? undefined : json['din'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'fees': !exists(json, 'fees') ? undefined : ((json['fees'] as Array<any>).map(FeeOptionFromJSON)),
        'price': !exists(json, 'price') ? undefined : json['price'],
    };
}

export function ImmunizationDescriptionToJSON(value?: ImmunizationDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'prescription': value.prescription,
        'din': value.din,
        'active': value.active,
        'fees': value.fees === undefined ? undefined : ((value.fees as Array<any>).map(FeeOptionToJSON)),
        'price': value.price,
    };
}

